/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Tutors_admin = {|
  +allTutors: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string;
        +firstname: ?string;
        +lastname: ?string;
        +createdAt: ?any;
        +openJobOffersCount: number;
        +startedJobsCount: number;
        +cellphoneNumber: ?string;
        +user: {|
          +email: string;
          +status: string;
        |};
      |};
    |}>;
    +pageInfo: {|
      +hasNextPage: boolean;
    |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "RootArgument",
      "name": "email",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "hasStartedJobs",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "hasOpenJobOffers",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "hasDocuments",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "status",
      "type": "[UserStatus]"
    },
    {
      "kind": "RootArgument",
      "name": "name",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "allTutors"
        ]
      }
    ]
  },
  "name": "Tutors_admin",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "allTutors",
      "args": [
        {
          "kind": "Variable",
          "name": "email",
          "variableName": "email",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "hasDocuments",
          "variableName": "hasDocuments",
          "type": "Boolean"
        },
        {
          "kind": "Variable",
          "name": "hasOpenJobOffers",
          "variableName": "hasOpenJobOffers",
          "type": "Boolean"
        },
        {
          "kind": "Variable",
          "name": "hasStartedJobs",
          "variableName": "hasStartedJobs",
          "type": "Boolean"
        },
        {
          "kind": "Variable",
          "name": "name",
          "variableName": "name",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "status",
          "variableName": "status",
          "type": "[UserStatus]"
        }
      ],
      "concreteType": "TutorConnection",
      "name": "__Tutors_allTutors_connection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TutorEdge",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Tutor",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "firstname",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "lastname",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "openJobOffersCount",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "startedJobsCount",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "cellphoneNumber",
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "status",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Admin"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/__generated__/Tutors_admin.graphql.js